import { api } from './api';

export async function enableWebPushNotifications(): Promise<boolean> {
  if (!('Notification' in window)) return false;

  let permission = Notification.permission;
  if (permission === 'default') {
    permission = await Notification.requestPermission();
  }

  if (permission !== 'granted') return false;

  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) {
        await api.patch('/auth/users/me/push-token', {
          pushToken: JSON.stringify(subscription.toJSON()),
        });
        return true;
      }
    } catch {
      // Web push subscription requires VAPID keys in production
    }
  }

  await api.patch('/auth/notification-prefs', { pushEnabled: true });
  return true;
}
